const groupNavbarFields = (fields) => {
  const ctaFields = fields.filter((field) => field.key === 'ctaText' || field.key === 'ctaUrl');
  const otherFields = fields.filter(
    (field) => !ctaFields.includes(field) && !field.key.startsWith('link-')
  );

  const linkGroups = [];
  for (let index = 1; index <= 20; index += 1) {
    const groupFields = fields
      .filter((field) => field.key.startsWith(`link-${index}-`))
      .sort((a, b) => a.sortOrder - b.sortOrder);

    if (!groupFields.some((field) => field.key === `link-${index}-label`)) {
      break;
    }

    linkGroups.push({ index, fields: groupFields });
  }

  return { ctaFields, linkGroups, otherFields };
};

export default groupNavbarFields;
